<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox"  :pageData="pageData"></table-page>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import URL from '@/views/cms/util/url'
  import UPDATE from '@/components/page/update.vue'
  import Qs from 'qs'
  import axios from 'axios'
  import DateUtil from '@/utils/IM/tradeDataUtil'
let status={0:'0-剛抓取',  1:'1-國片已處理', 2:'2-已分發'}
  let  langs={}
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    created(){
    this.initLangs();
    },

    methods: {

      initLangs(){
        this.$axios.post(URL.lang.query).then(res => {
          for (let i in res.result) {
            langs[res.result[i].code] = res.result[i].displayName;
          }
        })
      },
      checkbox(row){
        this.deleteIds = row.map(key => key.id).join(",");
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(data);
        }
      },

    },
    data () {
      return {
        deleteIds:"",
        queryData:{},

        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: 'title', field: 'title'},
              { title: 'lang', field: 'lang',required:true,type:2,optionList:langs},
              {click:"查询",auth:"cms:article:original"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.article.original, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
                          { title: 'title', field: 'title'},
                          { title: 'lang', field: 'lang'},
                          { title: 'source', field: 'source'},
                          { title: 'remark', field: 'remark'},
                          { title: 'status', field: 'status', render: (data, full) => {return status[data];}},
                          { title: 'utime', field: 'utime'},
                          { title: 'ctime', field: 'ctime',render: (data, full) => {
                              return DateUtil.formatDate(data, "yyyy-MM-dd hh:mm:ss");
                            }},

          ]
        }
      }
    }
  }
</script>
